import { useMemo } from 'react';
import type { GetValueFormItems, ThreeLevelsFilterValue, MappedFilterValue } from 'types';
import type { AppliedFilter } from 'store/entities/drawer';

/**
 * Hook to prepare filtered query parameters for agenda view records
 * Handles filtering of value form items and mapping of filter values
 */
export const useFilteredQuery = ({
  valueFormItems,
  filterValues,
  mapFilterValues,
}: {
  valueFormItems: GetValueFormItems[];
  filterValues: AppliedFilter[] | undefined;
  mapFilterValues: (filters: AppliedFilter[] | undefined) => MappedFilterValue[] | ThreeLevelsFilterValue[];
}) => {
  // Note: This is to cover case of a userId filtering and wrong items provided to filter
  const filteredItems = useMemo(() => {
    return valueFormItems.filter((item) => item.valueDirect !== null);
  }, [valueFormItems]);

  const itemsForValueRetrieval = useMemo(() => {
    return valueFormItems.filter((item) => item.valueDirect === null && item.valueFormItemId !== null && item.valueSourceType !== null);
  }, [valueFormItems]);

  const mappedFilterValues = useMemo(() => {
    return mapFilterValues(filterValues);
  }, [filterValues, mapFilterValues]);

  return {
    filteredItems,
    itemsForValueRetrieval,
    mappedFilterValues,
  };
};
